import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// mui
import { Box, Stack, Typography } from '@mui/material';
// component
import AvatarForm from '@/component/mui/AvatarForm';
// hook
// lib & store
import { inter } from '@/theme';
import { maskingEmail } from '@/lib/Masking';
import { useWeb3AuthConnect, useWeb3AuthUser } from '@web3auth/modal/react';

export default function MyPageInfo() {
  const { t } = useTranslation();
  const [name, setName] = useState<string>('member');
  // const [name, setName] = useState<string | undefined>(userInfo.email ? maskingEmail(userInfo.email) : 'member');
  // const { isWeb3, web3UserInfo } = useWeb3UserInfo();
  const { isConnected } = useWeb3AuthConnect();
  const { userInfo: web3authUserInfo, getUserInfo } = useWeb3AuthUser();

  useEffect(() => {
    (async () => {
      if (isConnected && web3authUserInfo) {
        // const re = await getUserInfo();
        setName(web3authUserInfo?.email ? maskingEmail(web3authUserInfo?.email) : 'member');
      }
    })();

    return () => {};
  }, [isConnected, web3authUserInfo]);
  return (
    <Stack gap={1.5} direction="row" alignItems="center" color="white" justifyContent="space-between">
      <Box>
        <Typography variant="h4" mb={1.5}>
          <strong>{name}</strong> {t('message.niceMeet')}
        </Typography>
        <Stack direction="row" alignItems="center">
          {/* <Typography variant="subtitle2" fontFamily={inter.style.fontFamily}>
            <strong>Lv.{userInfo.level}</strong>
          </Typography> */}
          {/* <Box width={2} height={8} bgcolor="#B9B5FF" mx={1.5} /> */}
          {/*{userInfo.referral && (
            <>
              <Typography variant="subtitle2" mr={1}>
            <strong>추천인코드</strong>
          </Typography>
          <Typography variant="subtitle2" fontFamily={inter.style.fontFamily}>
            <strong>{userInfo.referral}</strong>
          </Typography>
          <IconButton
            sx={{
              p: 0.5,
            }}
            onClick={() => {
              navigator.clipboard.writeText((userInfo.referral = ''));
              toast.success('추천인 코드가 클립보드에 복사되었습니다.');
            }}
          >
            <SFCopyIcon color="white" />
          </IconButton>
            </>
          )}*/}
        </Stack>
      </Box>
      <Box borderRadius="50%" p={0.5} border="2px solid white">
        <AvatarForm sxOptions={{ width: 64, height: 64 }} />
      </Box>
    </Stack>
  );
}
